import { render, staticRenderFns } from "./ProdutoLista.vue?vue&type=template&id=0bca57df&scoped=true&"
import script from "./ProdutoLista.vue?vue&type=script&lang=js&"
export * from "./ProdutoLista.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoLista.vue?vue&type=style&index=0&id=0bca57df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca57df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
